import React, { useState } from 'react';

import { Select } from '@aline/common';
import type { AutocompleteProps } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { AlineAutocompleteInput } from 'src/components';
import type { AnswerOptionSubset } from 'src/types';

interface AnswerOptionsAutocompleteProps extends Omit<
  AutocompleteProps<AnswerOptionSubset, false, false, false>,
  'renderInput'
> {
  options: AnswerOptionSubset[];
  inputClassName?: string;
  inputDataCy?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  placeholder?: string;
}

export function AnswerOptionsAutocomplete({
  inputClassName,
  inputDataCy = Select.components.answerOptionsAutocomplete.answerOptionsAutocompleteInput,
  inputRef,
  options,
  placeholder,
  ...rest
}: AnswerOptionsAutocompleteProps): JSX.Element {
  const [autocompleteOpen, setAutocompleteOpen] = useState<boolean>(false);

  return (
    <Autocomplete<AnswerOptionSubset, false, false, false>
      fullWidth
      openOnFocus
      getOptionLabel={option => option?.optionText ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      open={autocompleteOpen}
      options={options}
      renderInput={params => {
        return (
          <AlineAutocompleteInput
            {...params}
            ref={inputRef}
            inputClassName={inputClassName}
            inputProps={{
              ...params.slotProps.htmlInput,
              ['data-cy']: inputDataCy,
            }}
            placeholder={placeholder ?? 'Search options'}
          />
        );
      }}
      onClose={(): void => setAutocompleteOpen(false)}
      onOpen={(): void => setAutocompleteOpen(true)}
      {...rest}
    />
  );
}
